import React, { useState, useEffect } from 'react'
import { useCourt } from '../context/contextHooks';
import Container from "@mui/material/Container";
import Footer from './Footer';
import CustomFooter from "./CustomFooter";

const FooterSource = () => {
    const [court,] = useCourt();
    const [uiConfig, setUiConfig] = useState(null);

    useEffect(() => {
        if (court) {
            setUiConfig(court.footerConfig);
        } else setUiConfig(null);
    }, [court])

    return (
        <Container maxWidth={false} style={{padding: '0'}} sx={{marginTop: 'auto'}}>
            { uiConfig ?
                <CustomFooter uiConfig={uiConfig} /> :
                <Footer/>
            }
        </Container>
    )
}

export default FooterSource;
